import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import FeatureCards from './components/FeatureCards';
import CategoryGrid from './components/CategoryGrid';
import TrustSection from './components/TrustSection';
import SEOContent from './components/SEOContent';
import ArticlesPreview from './components/ArticlesPreview';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        {/* Schema.org Organization */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: 'Itaobuy Spread',
              url: 'https://itaobuyspread.cyou',
              description: 'Il punto di riferimento italiano per guide, analisi e categorie su Itaobuy Spreadsheet.',
              sameAs: ['https://kaspreadsheet.com'],
            }),
          }}
        />

        <Hero />
        <AboutSection />
        <FeatureCards />
        <CategoryGrid />
        <TrustSection />
        <SEOContent />
        <ArticlesPreview />

        {/* Schema.org FAQ */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: 'Cos\'è Itaobuy Spreadsheet?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Itaobuy Spreadsheet è una piattaforma che organizza prodotti e categorie in formato tabellare, facilitando la ricerca e il confronto tra migliaia di articoli di moda e accessori.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Come si usa Itaobuy Spreadsheet?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Basta selezionare una categoria dal menu a tendina o dalla griglia prodotti per accedere alle liste organizzate.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Itaobuy Spreadsheet è gratuito?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'L\'accesso alle informazioni e alle categorie di Itaobuy Spreadsheet è completamente gratuito.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Quali categorie sono disponibili?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Sono disponibili 14 categorie tra cui Scarpe, Felpe, T-Shirt, Giacche, Pantaloni, Cappelli, Accessori, Borse, Profumi e molto altro.',
                  },
                },
              ],
            }),
          }}
        />

        <CTASection />
      </main>
      <Footer />
    </>
  );
}